import styles from "./styles.module.scss";

export const ChartLose = ({isWalky}) => {
  return (
    <svg
      width="343"
      height="262"
      viewBox="0 0 343 262"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_8_56)">
        <rect width="343" height="262" fill="#F8F8F8" />
        <g filter="url(#filter0_d_8_56)">
          <rect x="48" y="49" width="49" height="27" rx="7" fill="white" />
          <path
            d="M48 69L40.1225 63.3107C39.5698 62.9115 39.5698 62.0885 40.1225 61.6893L48 56L48 69Z"
            fill="white"
          />
        </g>
        <rect
          width="303"
          height="1"
          transform="matrix(-1 0 0 1 323 94.5)"
          fill="#D9D9D9"
        />
        <rect
          width="303"
          height="1"
          transform="matrix(-1 0 0 1 323 137)"
          fill="#D9D9D9"
        />
        <rect
          width="303"
          height="1"
          transform="matrix(-1 0 0 1 323 179.5)"
          fill="#D9D9D9"
        />
        <rect
          width="303"
          height="1"
          transform="matrix(-1 0 0 1 323 222)"
          fill="#D9D9D9"
        />
        <path
          opacity="0.2"
          d="M56 222V116.5M140.5 222V151M223 222V170.5M322.5 222V205"
          stroke="#171717"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2 2"
        />
        <path
          className={styles.grow}
          d="M20 63C46.0474 83.5099 56.6789 156.693 124.189 151.1C228.911 143.641 253.363 208.9 323 203.705"
          stroke="url(#paint0_linear_8_56)"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          className={styles.show}
          d="M124.189 151.1C56.6789 156.693 46.0474 83.5099 20 63V222H323V203.705C253.363 208.9 228.911 143.641 124.189 151.1Z"
          fill="url(#paint1_linear_8_56)"
          fillOpacity="0.12"
        />
        <rect
          className={styles.show}
          x="258"
          y="132"
          width="72"
          height="44"
          rx="7"
          fill={isWalky ?"#E7394F" : "#7C8AF7" }
        />
        <path
          className={styles.show}
          d="M321 176L314.23 183.222C313.834 183.643 313.166 183.643 312.77 183.222L306 176H321Z"
          fill={isWalky ?"#E7394F" : "#7C8AF7" }
        />
        <g filter="url(#filter1_d_8_56)">
          <circle
            className={styles.show}
            cx="322"
            cy="204"
            r="5"
            fill="white"
            shapeRendering="crispEdges"
          />
          <circle
            className={styles.show}
            cx="322"
            cy="204"
            r="6"
            stroke="black"
            strokeOpacity="0.16"
            strokeWidth="2"
            shapeRendering="crispEdges"
          />
        </g>
        <g filter="url(#filter2_d_8_56)">
          <circle
            cx="21"
            cy="63"
            r="5"
            fill="white"
            shapeRendering="crispEdges"
          />
          <circle
            cx="21"
            cy="63"
            r="6"
            stroke="black"
            strokeOpacity="0.16"
            strokeWidth="2"
            shapeRendering="crispEdges"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_8_56"
          x="23"
          y="33"
          width="90"
          height="59"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="8" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8_56"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8_56"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_8_56"
          x="307"
          y="189"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8_56"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8_56"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_8_56"
          x="6"
          y="48"
          width="30"
          height="30"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8_56"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8_56"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_8_56"
          x1="20"
          y1="133.386"
          x2="323"
          y2="133.386"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F91E1E" />
          <stop offset="0.26" stopColor="#FFA51F" />
          <stop offset="0.465" stopColor="#F9ED2A" />
          <stop offset="0.725" stopColor="#64EC82" />
          <stop offset="1" stopColor="#36E6E6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8_56"
          x1="20"
          y1="63"
          x2="308.5"
          y2="212.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F91E1E" />
          <stop offset="0.26" stopColor="#FFA51F" />
          <stop offset="0.465" stopColor="#F9ED2A" />
          <stop offset="0.725" stopColor="#64EC82" />
          <stop offset="1" stopColor="#36E6E6" />
        </linearGradient>
        <clipPath id="clip0_8_56">
          <rect width="343" height="262" rx="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
